import classNames from 'classnames';
import { memo } from 'react';
import css from './OutlinedInputLabel.module.scss';
import { ErrorLevel } from '../../../../API/Enums';
import { GoMotoComponent } from '../../../../API/GoMoto.types';
import { GMOutlinedInputLabelProps } from '..';

/**
 * Input label for use with variant='outlined' input controls
 */
const GMOutlinedInputLabel: GoMotoComponent<GMOutlinedInputLabelProps> = memo(({
    label,
    required,
    error = ErrorLevel.None,
    disabled,
    color = 'dark',
}) => {
    return (
        label ?
            <div
                className={classNames(
                    css.inputLabel,
                    {
                        [css.dark]: color === 'dark',
                        [css.light]: color === 'light',
                        [css.disabled]: disabled,
                        [css.error]: error === ErrorLevel.Error,
                        [css.warning]: error === ErrorLevel.Warning,
                    },
                )}
            >
                {label}{required ? ' *' : ''}
            </div> : null
    );
});

export default GMOutlinedInputLabel;